// extracted by mini-css-extract-plugin
export var confirm = "search-module--confirm--7e439";
export var image = "search-module--image--58e91";
export var searchBar = "search-module--searchBar--1c574";